import { render, staticRenderFns } from "./bindOrder.vue?vue&type=template&id=2453255b&scoped=true"
import script from "./bindOrder.vue?vue&type=script&lang=js"
export * from "./bindOrder.vue?vue&type=script&lang=js"
import style0 from "./bindOrder.vue?vue&type=style&index=0&id=2453255b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453255b",
  null
  
)

export default component.exports